import { createReducer } from "@reduxjs/toolkit";

// 1st parameter is initial state and 2nd parameter is Action.type
export const userReducer = createReducer(
  {},
  {
    loginRequest: (state) => {
      state.loading = true;
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.message = action.payload.message;
    },
    loginFail: (state, action) => {
      state.loading = false;
      state.isAuthenticated = false;
      // state.user = action.payload.user,
      state.error = action.payload;
    },

    registerRequest: (state) => {
      state.loading = true;
    },
    registerSuccess: (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.message = action.payload.message;
    },
    registerFail: (state, action) => {
      state.loading = false;
      state.isAuthenticated = false;
      // state.user = action.payload.user,
      state.error = action.payload;
    },


    logoutRequest: (state) => {
      state.loading = true;
    },
    logoutSuccess: (state, action) => {
      state.loading = false;
      state.isAuthenticated = false;
      state.user = null;
      state.message = action.payload.message;
    },
    logoutFail: (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      // state.user = action.payload.user,
      state.error = action.payload;
    },


    loadUserRequest: (state) => {
      state.loading = true;
    },
    loadUserSuccess: (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    loadUserFail: (state, action) => {
      state.loading = false;
      state.isAuthenticated = false;
      // state.user = action.payload.user,
      state.error = action.payload;
    },


    removeFromPlaylistRequest : (state) => {
      state.loading = true;
  },
  removeFromPlaylistSuccess : (state, action) => {
      state.loading = false;
      state.message = action.payload
  },
  removeFromPlaylistFail : (state, action) => {
      state.loading = false;
      state.error = action.payload
  },
  

    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  }
);




export const profileReducer = createReducer(
  {},
  {
    updateProfileRequest : (state) => {
      state.loading = true;
    },
    updateProfileSuccess : (state, action) => {
      state.loading = false;
      state.message  = action.payload;

    },
    updateProfileFail : (state, action) => {
      state.loading = false;
      state.error  = action.payload;
    },


    changePasswordRequest : (state) => {
      state.loading = true;
    },
    changePasswordSuccess : (state, action) => {
      state.loading = false;
      state.message  = action.payload;

    },
    changePasswordFail : (state, action) => {
      state.loading = false;
      state.error  = action.payload;
    },

    updatePictureRequest : (state) => {
      state.loading = true;
    },
    updatePictureSuccess : (state, action) => {
      state.loading = false;
      state.message  = action.payload;

    },
    updatePictureFail : (state, action) => {
      state.loading = false;
      state.error  = action.payload;
    },

    
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },

  })



  
export const subscriptionReducer = createReducer(
  {},
  {
    createSubscriptionRequest : (state) => {
      state.loading = true;
    },
    createSubscriptionSuccess : (state, action) => {
      state.loading = false;
      state.subscriptionId  = action.payload;

    },
    createSubscriptionFail : (state, action) => {
      state.loading = false;
      state.error  = action.payload;
    },


    cancelSubscriptionRequest : (state) => {
      state.loading = true;
    },
    cancelSubscriptionSuccess : (state, action) => {
      state.loading = false;
      state.message  = action.payload;

    },
    cancelSubscriptionFail : (state, action) => {
      state.loading = false;
      state.error  = action.payload;
    },


    
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },

  })
